import KEYS from '@/values/keys';
import { staffI18n } from '../lang/staff.i18n'
import { i18n } from '@/core/lang/core.i18n'

export const STAFF_STORE_NAME = 'StaffStore';

export enum API_VARIABLES {
  EMAIL = '{email}',
  ORGANIZATION_ID = '{organizationId}',
  ID = '{id}',
  ZIPCODE = '{zipcode}'
}

export const ROLES_VALUES = [
  { text: i18n.t('tools.staff.status.student'), value: 'STUDENT', disabled: false },
  { text: i18n.t('tools.staff.status.teacher'), value: 'TEACHER', disabled: false },
  { text: i18n.t('tools.staff.status.sa'), value: 'SA', disabled: false },
  { text: i18n.t('tools.staff.status.sda'), value: 'SDA', disabled: false }
]

export const ACTIONS = {
  INVITE_USER:'inviteUserA',
  GET_ORGANIZATION_USERS_A: 'getUsersByOrganizationA',
  SEARCH_USERS_ORGANIZATION_A: 'searchUsersOrganizationA',
  GET_UNREGISTERED_USERS_A: 'getUnregisteredUsersA',
  SEARCH_UNREGISTERED_USERS_A: 'searchUnregisteredUsersA',
  REMOVE_USER_FROM_ORGANIZATION_A: 'removeUserFromOrganizationA'
}

export const MUTATIONS = {
  SET_ORGANIZATION_USERS_M:'setOrganizationUsersM',
  SET_FILTER_ORGANIZATION_USERS_M:'setFilterOrganizationUsersM',
  SET_UNREGISTERED_USERS_M:'setUnregisteredUsersM',
  SET_FILTER_UNREGISTERED_USERS_M:'setFilterUnregisteredUsersM',
  REMOVE_USER_FROM_ORGANIZATION_M: 'removeUserFromOrganizaitionM',
  RESET_USERS_M: 'resetUsersM'
}

export const _STAFF_STORE = {
  NAME: STAFF_STORE_NAME,
  MUTATIONS: {
    SET_ORGANIZATION_USERS_M: `${STAFF_STORE_NAME}/${MUTATIONS.SET_ORGANIZATION_USERS_M}`,
    SET_FILTER_ORGANIZATION_USERS_M: `${STAFF_STORE_NAME}/${MUTATIONS.SET_FILTER_ORGANIZATION_USERS_M}`,
    SET_UNREGISTERED_USERS_M: `${STAFF_STORE_NAME}/${MUTATIONS.SET_UNREGISTERED_USERS_M}`,
    SET_FILTER_UNREGISTERED_USERS_M: `${STAFF_STORE_NAME}/${MUTATIONS.SET_FILTER_UNREGISTERED_USERS_M}`,
    REMOVE_USER_FROM_ORGANIZATION_M: `${STAFF_STORE_NAME}/${MUTATIONS.REMOVE_USER_FROM_ORGANIZATION_M}`,
    RESET_USERS_M: `${STAFF_STORE_NAME}/${MUTATIONS.RESET_USERS_M}`,
  },
  ACTIONS: {
    INVITE_USER_A: `${STAFF_STORE_NAME}/${ACTIONS.INVITE_USER}`,
    GET_ORGANIZATION_USERS_A: `${STAFF_STORE_NAME}/${ACTIONS.GET_ORGANIZATION_USERS_A}`,
    SEARCH_USERS_ORGANIZATION_A: `${STAFF_STORE_NAME}/${ACTIONS.SEARCH_USERS_ORGANIZATION_A}`,
    GET_UNREGISTERED_USERS_A: `${STAFF_STORE_NAME}/${ACTIONS.GET_UNREGISTERED_USERS_A}`,
    SEARCH_UNREGISTERED_USERS_A: `${STAFF_STORE_NAME}/${ACTIONS.SEARCH_UNREGISTERED_USERS_A}`,
    REMOVE_USER_FROM_ORGANIZATION_A: `${STAFF_STORE_NAME}/${ACTIONS.REMOVE_USER_FROM_ORGANIZATION_A}`
  }
}

export const STAFF_API = {
  INVITE_USER: 'register/admin/submitRegisterUsers/{organizationId}',
  FIND_PERSON: 'register/admin/findPerson?email={email}',
  GET_ORGANIZATION_USERS: 'organization/{organizationId}/users/',
  SEARCH_USERS_ORGANIZATION: 'organization/internal/organization/{organizationId}/users/search',
  GET_UNREGISTERED_USERS: 'organization/unregisteredUsers',
  SEARCH_UNREGISTERED_USERS: 'organization/unregisteredUsers/search',
  REMOVE_USER_FROM_ORGANIZATION: 'organization/users/{id}',
  GET_ZIPCODE: 'address/zipGeocoords?zipCode={zipcode}',
  GET_COUNTRIES: 'internal/address/countries',
}